export const ANIMATE_LIST = 'ANIMATE_LIST';
export const MAIN_ANIMATE_SWITCH = 'MAIN_ANIMATE_SWITCH';
export const CURRENT_ANIMATE = 'CURRENT_ANIMATE';
export const ANIMATE_PLAY_STATUS = 'ANIMATE_PLAY_STATUS';
